import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { Col } from "shards-react";

import SidebarMainNavbar from "./SidebarMainNavbar";
import SidebarNavItems from "./SidebarNavItems";

class MainSidebar extends React.Component {
  render() {
    const classes = classNames(
      "main-sidebar",
      "px-0",
      "col-12",
      this.props.sideBarVisibility && "open"
    );

    return (
      <Col tag="aside" className={classes} lg={{ size: 2 }} md={{ size: 3 }}>
        <SidebarMainNavbar
          hideLogoText={this.props.hideLogoText}
          toggleSideBar={this.props.toggleSideBar}
        />
        {/*<SidebarSearch />*/}
        <SidebarNavItems toggleSideBar={this.props.toggleSideBar} />
      </Col>
    );
  }
}

MainSidebar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool,
  sideBarVisibility: PropTypes.bool,
};

MainSidebar.defaultProps = {
  hideLogoText: false,
  sideBarVisibility: false,
};

export default MainSidebar;
